"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEventValue = isValidEventValue;
exports.eventAtomProcessor = eventAtomProcessor;
exports.getEventAtomSubRuleId = exports.getNextEventAtom = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _debtinatorAtom = require("../utils/debtinator-atom");

var _RuleEditorSelect = _interopRequireWildcard(require("../../rule-editor/atoms/RuleEditorSelect"));

var RuleEditorEvent = function RuleEditorEvent(_ref) {
  var atom = _ref.atom,
      value = _ref.value,
      setValue = _ref.setValue;
  return /*#__PURE__*/_react.default.createElement(_RuleEditorSelect.default, {
    atom: atom,
    value: value,
    setValue: setValue
  });
};

var _default = RuleEditorEvent;
exports.default = _default;
var getNextEventAtom = _RuleEditorSelect.getNextSelectAtom;
exports.getNextEventAtom = getNextEventAtom;
var getEventAtomSubRuleId = _RuleEditorSelect.getSelectAtomSubRuleId;
exports.getEventAtomSubRuleId = getEventAtomSubRuleId;

function isValidEventValue(atom) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      value = _ref2.value;

  var hasValue = atom.options.some(function (o) {
    return o.value === value;
  });
  return atom.type === "event" && hasValue;
}

function eventAtomProcessor(idx, atom, values) {
  return (0, _debtinatorAtom.getEventsForAtom)(idx, atom, values);
}